import debounce from 'debounce';
import { mapMutations } from 'vuex';
export default {
  data() {
    return {
      fetching: false,
      field: '',
    };
  },
  computed: {
    setName() {
      return this.name;
    },
    getValueData() {
      if (typeof this.value === 'object') {
        return this.value.name.toString().toLowerCase();
      }
      return this.value.toString();
    },
    showLable() {
      return this.translation ? this.$t(`${this.translation}.label`) : this.name;
    },
  },
  props: {
    /**
     * The field name.
     */
    name: {
      type: [String, Number],
      required: true,
    },

    /**
     * The field value.
     */
    value: {
      type: [String, Object, Number],
      required: false,
      default: '',
    },

    /**
     * The options for the select field. Should be a array of objects with id and name attributes.
     */
    options: {
      type: Array,
      required: false,
      default: () => [],
    },

     /**
     * The displays for the select field. Should be a array of objects with id and name attributes.
     */
    info: {
      type: [Array, Object],
      required: false,
      default: () => [],
    },

    /**
     * The base key to translate the form.
     */
    translation: {
      type: String,
      required: false,
    },

    /**
     * If the input has label.
     */
    hasLabel: {
      type: Boolean,
      required: false,
    },

    /**
     * If the input has error.
     */
    error: {
      type: String,
      required: false,
    },

    /**
     * If the input has error.
     */
    insideForm: {
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * The remote class to fetch suggestions.
     * @type {Object}
     */
    remote: {
      type: Object,
      required: false,
      default: () => {},
    },

    /**
    * To check if we use remote
    */
    isSearch:{
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * Method to fetch options from server.
     */
    searchMethod: {
      type: Function,
      required: false,
      default: () => {},
    },

    /**
     * If the input is disabled.
     */
    disabled: {
      type: Boolean,
      default: false,
    },

     /**
     * The component to add another option.
     */
    quickForm: {
      type: Object,
      required: false,
    },
  },
  mounted() {
    // console.log(this.quickForm);
  //  console.log(this.info);
   //  console.log(this.options);
  },
  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * This method will be called when input event is fired.
     *
     * @param  {String} name    The field name.
     */
    onInput(name) {
      return (value) => {
        this.$emit('change', name, value);
      };
    },

    onQuickFormClick() {
      this.setModalContent(this.quickForm);
      this.toggleModal(true);
    },
    getValue() {
      if (typeof this.value === 'object') {
        return this.value.name.toString().toLowerCase();
      }
      return this.value;
    },
    showHtml(item) {
      let html = '';

      if (typeof item === 'object') {
        if( item.options !== undefined ) {
          const details = this.showDetails(item);
          html = `<div class="name"> ${item.name} </div>`;
          html += `<span class="details"> ${details} </span>`;
        } else if ( item.fieldsJSON !== undefined) {
          const details = this.showDetails(item);
          html = `<div class="name"> ${item.name} </div>`;
          html += `<span class="details"> ${details} </span>`;
        } else {
           html = `<div class="item"> ${item.name} </div>`;
        }

      } else {
        html = `<div class="item"> ${item} </div>`;
      }
      //console.log(item);
      return html;
    },

    showDetails(item){
       let details = '';
       let tagsOptions =  this.$i18n.messages[this.$i18n.locale].form.products;
       //console.log(this.info);
       for (var i = 0; i < this.info.length; i++) {
          if(item[this.info[i]] !== undefined) {
            details+= tagsOptions[this.info[i]].label+ ": "+ item[this.info[i]];
          }else {
            if (item.options !== undefined) {
              if (item.options.fieldsJSON[this.info[i]] !== undefined){
                details+= tagsOptions[this.info[i]].label+ ": "+ item.options.fieldsJSON[this.info[i]];
              }else{
                details+= tagsOptions[this.info[i]].label+ ": ";
              }
            }else if (item.fieldsJSON !== undefined) {
              if (item.fieldsJSON[this.info[i]] !== undefined){
                details+= tagsOptions[this.info[i]].label+ ": "+ item.fieldsJSON[this.info[i]];
              }else{
                details+= tagsOptions[this.info[i]].label+ ": ";
              }
            }
          }

          if( i < this.info.length-1){
            details+= " | ";
          }
       }

       return details;
    },
    handleSelect(item) {
      this.$emit('keydown', this.name, item);
    },

    changeData(string){
     // console.log(string);
      this.$emit('keydown', this.name, {name:'',id:0});
    },

    fetchLocal(queryString, cb){
      // If remote object is not set, then fetch from local.
      if (this.remote === undefined || !Object.keys(this.remote).length) {
        const options = this.options.map((o) => {
          o.value = o.name.toString().toLowerCase();
          return o;
        });
        const createFilter = option => (option.value.indexOf(queryString.toLowerCase()) === 0);
        const results = queryString ? options.filter(createFilter) : options;
        cb(results);
        return;
      }

      if (this.fetching) return;

      this.fetching = true;

      if (queryString === '') {
        queryString = 0;
      }

      this.remote.fetchSuggestions(queryString).then((suggestions) => {
        this.fetching = false;
        // this.options = suggestions.map(o => ({ name: o.postalCode }));
        const opts = suggestions.map(o => ({ name: o.postalCode }));

        const options = opts.map((o) => {
          o.value = o.name.toString().toLowerCase();
          return o;
        });

        const createFilter = option => (option.value.indexOf(queryString.toLowerCase()) === 0);
        const results = queryString ? options.filter(createFilter) : options;
        cb(results);
      });
    },

    fetchServer(queryString, cb){
      this.fetching = true;
      this.searchMethod(queryString).then((data) => {
         this.fetching = false;
         // console.log(data);
        const options = data[0].map((o) => {
          o.value = o.name.toString().toLowerCase();
            return o;
        });

        cb(options);

      });


    },
    /* eslint no-console: ["error", { allow: ["log", "error"] }] */
    fetchSuggestions: debounce( function(queryString, cb) {
        if(this.isSearch){
          this.fetchServer(queryString, cb);
        }else{
          this.fetchLocal(queryString, cb);
        }
    }, 800),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/form/autocomplete/autocomplete.js